import { FormControl, FormGroup } from "@angular/forms";
import { LookupModel } from "src/app/models/common/lookup.model";

export class CommunicationLogModel {
  saleName: string;
  //hip: string;
  lot?: string;
  lotNumber?: number;
  lotNumberSuffix?: string;
  communicationType: string;
  mailTypeName: string;
  from: string;
  company: string;
  to: string;
  emailTo: string;
  subject: string;
  sentDateUtc: Date;
  status: string;
  static asFormGroup(): FormGroup {
    const fg = new FormGroup({
      saleName: new FormControl(""),
      communicationType: new FormControl(""),
      mailTypeName: new FormControl(""),
      from: new FormControl(""),
      company: new FormControl(""),
      to: new FormControl(""),
      search: new FormControl(""),
      status: new FormControl(""),
      sentMailTypeId: new FormControl(""),
      sendGridEventId: new FormControl(""),
      deliveryTypeId: new FormControl(""),
      isWhatsApp: new FormControl(""),
      whatsAppStatus: new FormControl(""),
      whatsAppStatusId: new FormControl(""),
      isSMS: new FormControl(""),
      smsStatus: new FormControl(""),
      smsStatusId: new FormControl(""),
    });
    return fg;
  }
}

export enum CommunicationLogTableFields {
  COMMUNICATION_TYPE = 'communicationType',
  SALE_NAME = 'saleName',
  SUBJECT = 'subject',
  HIP = 'hip',
  MAIL_TYPE_NAME = 'mailTypeName',
  FROM = 'from',
  COMPANY = 'company',
  TO = 'to',
  EMAIL_TO = 'emailTo',
  SENT_DATE = 'sentDate',
  STATUS_DETAIL = 'status',
}

export class DeliveryTypeDto {
  deliveryTypeId: number;
  deliveryTypeName: string;
}

export class SentMailTypeDto {
  sentMailTypeId: number;
  sentMailTypeName: string;
}

export class MessageEventDto {
  sendGridEventTypeId: number;
  eventType: string;
  eventBehaviourClassId: number;
}

export class CommunicationLogLookupsModel {
  deliveryTypes: DeliveryTypeDto[];
  sentMailTypes: SentMailTypeDto[];
  messageEvents: MessageEventDto[];
  allSales: LookupModel[];
  allRecipients: LookupModel[];
}
export class CommunicationLogDto {
  communicationLogList: CommunicationLogModel[];
  totalPages: number;
  totalRecords: number;  
}
export class CommunicationLogPagingGetDto {
  saleId?: number | null;
  recipientId?: string | null;
  currentPage?: number | null;
  itemsPerPage?: number | null;
  deliveryTypeId?: number | null;
  sentMailTypeId?: number | null;
  sendGridEventTypeId?: number | null;
  search?: string | null;
}

